<h2>Home Component</h2>
<p>This is where you end up right after logging in. ...like a "dashboard".</p>
<p>
  There is a second view here
  <a class="color-secondary" [routerLink]="['view2']">(view2)</a> if you need it for any reason. Feel free to delete it if not needed.
</p>
